import React, { useState, useEffect } from "react";
import {
	Button,
	Modal,
	Box,
	Typography,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	CircularProgress,
} from "@mui/material";
import { generateClient } from "aws-amplify/api";
import { listAgreements } from "../../graphql/queries";
import { setAgreementDetails } from "../../redux/slices/agreementFormSlice";
import { useDispatch } from "react-redux";
import {
	handleCompleteStep,
	handleStep,
} from "../../redux/slices/addNewContentStepsSlice";
import { useNavigate } from "react-router-dom";
import moment from "moment";

// Modal style
const modalStyle = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 4,
};

const CreateContentModal = () => {
	const [open, setOpen] = useState(false);
	const [agreements, setAgreements] = useState([]);
	const [selectedAgreement, setSelectedAgreement] = useState("");
	const [loading, setLoading] = useState(false);
	const client = generateClient();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	// Fetch agreements when the modal is opened
	useEffect(() => {
		if (open) {
			fetchAgreements();
		}
	}, [open]);

	const fetchAgreements = async () => {
		try {
			setLoading(true);
			const response = await client.graphql({
				query: listAgreements,
			});
			const contentList = response.data.listAgreements.items;

			setAgreements(contentList);
		} catch (error) {
			console.error("Error fetching agreements:", error);
		} finally {
			setLoading(false);
		}
	};

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const handleAgreementChange = (event) => {
		setSelectedAgreement(event.target.value);
	};

	return (
		<div>
			<Button variant="contained" color="primary" onClick={handleOpen}>
				Create Content
			</Button>

			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="create-content-modal"
				aria-describedby="select-agreement-modal"
			>
				<Box sx={modalStyle}>
					<Typography
						id="create-content-modal"
						variant="h6"
						component="h2"
					>
						Select an Agreement
					</Typography>

					{loading ? (
						<CircularProgress />
					) : (
						<FormControl fullWidth sx={{ mt: 2 }}>
							<InputLabel id="agreement-select-label">
								Agreement
							</InputLabel>
							<Select
								labelId="agreement-select-label"
								id="agreement-select"
								value={selectedAgreement}
								label="Agreement"
								onChange={handleAgreementChange}
							>
								{agreements.map((agreement) => (
									<MenuItem
										key={agreement.id}
										value={agreement.id}
									>
										{agreement?.agreementFilePath
											?.split("/")
											?.pop()}{" "}
										{moment(agreement.createdAt).format(
											"DD MMM YYYY"
										)}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					)}

					<Box sx={{ mt: 3 }}>
						<Button
							variant="contained"
							color="secondary"
							onClick={handleClose}
						>
							Cancel
						</Button>
						<Button
							variant="contained"
							color="primary"
							disabled={!selectedAgreement}
							onClick={() => {
								const agreementDetails = agreements?.find(
									(agreement) =>
										agreement.id === selectedAgreement
								);
								console.log(
									agreementDetails,
									"agreementDetails"
								);
								dispatch(setAgreementDetails(agreementDetails));
								dispatch(handleCompleteStep(0));
								dispatch(handleCompleteStep(1));
								navigate("/add-new-content");
							}}
							sx={{ ml: 2 }}
						>
							Submit
						</Button>
					</Box>
				</Box>
			</Modal>
		</div>
	);
};

export default CreateContentModal;
